import {Component, inject} from '@angular/core';
import {ColComponent, ContainerComponent, RowComponent} from "@coreui/angular";
import {MatError, MatFormField, MatLabel} from "@angular/material/form-field";
import {MatInput} from "@angular/material/input";
import {MatButton} from "@angular/material/button";
import {PlayersService} from "../../services/players.service";
import {
  AbstractControl,
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  ValidationErrors,
  ValidatorFn,
  Validators
} from "@angular/forms";
import {PlayerInfoTableDefs} from "../../components/player-game-info/player-info-table-defs";
import {AgGridAngular} from "ag-grid-angular";
import {UIStateEnum} from "../../enum/UIStateEnum";
import {GridApi, GridReadyEvent} from "ag-grid-community";
import {IPlayerEmail} from "../../interfaces/player/IPlayerEmail";
import {IPlayerEmailFilterParams} from "../../interfaces/player/IPlayerEmailFilterParams";
import {MatCard} from "@angular/material/card";
import {ErrorHandlingService} from "../../services/error-handling.service";

@Component({
  selector: 'app-player-email-history',
  standalone: true,
  imports: [
    ContainerComponent,
    MatFormField,
    MatInput,
    MatButton,
    ReactiveFormsModule,
    AgGridAngular,
    MatLabel,
    MatError,
    RowComponent,
    ColComponent,
    MatCard
  ],
  templateUrl: './player-email-history.component.html',
  styleUrl: './player-email-history.component.css'
})
export class PlayerEmailHistoryComponent {

  private playerService = inject(PlayersService);
  private playerInfoTableDefs = inject(PlayerInfoTableDefs);
  private errorHandlingService: ErrorHandlingService = inject(ErrorHandlingService);

  public emailControl: FormControl<string | null> = new FormControl('', Validators.email);
  public playerIdControl: FormControl<string | null> = new FormControl('', this.guidValidator());

  public emailHistoryForm: FormGroup = new FormGroup({
    email: this.emailControl,
    playerId: this.playerIdControl,
  });

  protected readonly uiStateEnum = UIStateEnum;
  public uiState = UIStateEnum.ShowData;
  public emailHistoryColDefs = this.playerInfoTableDefs.playerEmailSearchColDefs;
  public emailHistoryGridApi!: GridApi<IPlayerEmail>
  public playerEmails: IPlayerEmail[] = [];

  public onSearchButtonClick() {
    if ((this.emailControl.value?.trim() == "" && this.playerIdControl.value == "") || !this.emailHistoryForm.valid) {
      return;
    }

    this.uiState = UIStateEnum.ShowLoading;

    let filter_params: IPlayerEmailFilterParams = {
      Email: this.emailControl.value!.trim(),
      PlayerId: this.playerIdControl.value!
    };

    this.playerService.getEmailChangeByFilterParams(filter_params).subscribe({
      next: email_changes => {
        this.playerEmails = email_changes;
        this.uiState = UIStateEnum.ShowData;
      },
      error: error => {
        this.playerEmails = [];
        this.uiState = UIStateEnum.ShowData;
        this.errorHandlingService.displayPageLevelErrorMessage("Failed to search email history", error);
      }
    });
  }

  public onEmailHistoryGridReady(params: GridReadyEvent<IPlayerEmail>) {
    this.emailHistoryGridApi = params.api;
    this.emailHistoryGridApi.sizeColumnsToFit({
      defaultMinWidth: 100
    });
  }

  private guidValidator(): ValidatorFn {
    let guid_regex = RegExp("^$|^[0-9a-fA-F]{8}-([0-9a-fA-F]{4}-){3}[0-9a-fA-F]{12}$");
    return (control: AbstractControl): ValidationErrors | null => {
      if (control.value.match(guid_regex))
      {
        return null;
      }
      return {error: "Invalid Guid"};
    }
  }

  onResetButtonClick() {
    this.emailControl.setValue("");
    this.playerIdControl.setValue("");

    this.playerEmails = [];
  }
}
